<template>
  <div class="top-bottom-box" ref="container" :style="{ height: height }">
    <div class="top" :style="{ height: topHeight + 'px' }" v-if="$slots.top">
      <slot name="top"></slot>
    </div>
    <div
      class="line"
      @mousedown="startDrag"
      :class="{ dragging: isDragging }"
      v-if="$slots.top && $slots.bottom"
    >
      <div class="drag-handle">
        <svg class="drag-icon" viewBox="0 0 24 24" width="12" height="12">
          <circle cx="6" cy="12" r="1.5" fill="currentColor" />
          <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          <circle cx="18" cy="12" r="1.5" fill="currentColor" />
        </svg>
      </div>
    </div>
    <div class="bottom" :style="bottomStyle">
      <slot name="bottom" v-if="$slots.bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBottomBox',
  props: {
    height: {
      type: String,
      default: '100%'
    },
    topHeightDefault: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      topHeight: 300,
      containerHeight: 0,
      isDragging: false,
      startY: 0,
      startTopHeight: 0
    }
  },
  computed: {
    bottomStyle() {
      if (!this.$slots.top || !this.$slots.bottom) {
        return { height: '100%' }
      }
      return { height: `calc(100% - ${this.topHeight}px - 12px)` }
    }
  },
  created() {
    this.topHeight = this.topHeightDefault
  },
  mounted() {
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.stopDrag)
    window.addEventListener('resize', this.initContainer)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    window.removeEventListener('resize', this.initContainer)
  },
  methods: {
    // 初始化容器高度，供拖拽边界计算使用
    initContainer() {
      this.containerHeight = this.$refs.container?.offsetHeight
    },

    // 获取容器高度，未初始化时即时计算
    getContainerHeight() {
      if (this.containerHeight) return this.containerHeight
      this.initContainer()
      return this.containerHeight
    },

    // 开始上下拖拽
    startDrag(e) {
      this.isDragging = true
      this.startY = e.clientY
      this.startTopHeight = this.topHeight
      e.preventDefault()
    },

    // 拖拽过程中更新顶部区域高度
    onDrag(e) {
      if (!this.isDragging) return

      const deltaY = e.clientY - this.startY
      let newTopHeight = this.startTopHeight + deltaY

      const minHeight = 100
      const maxHeight = this.getContainerHeight() - 100 - 12

      newTopHeight = Math.max(minHeight, Math.min(maxHeight, newTopHeight))
      this.topHeight = newTopHeight
    },

    // 停止拖拽
    stopDrag() {
      this.isDragging = false
    }
  }
}
</script>

<style scoped lang="less">
.top-bottom-box {
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  > div {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  .line {
    overflow: hidden;
    height: 6px;
    width: 100%;
    background: linear-gradient(
      to right,
      #f8f9fa 0%,
      #e9ecef 50%,
      #f8f9fa 100%
    );
    cursor: row-resize;
    flex-shrink: 0;
    position: relative;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    margin: 3px 0;

    &:hover {
      background: linear-gradient(
        to right,
        #e9ecef 0%,
        #dee2e6 50%,
        #e9ecef 100%
      );
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      .drag-handle {
        background: rgba(108, 117, 125, 0.1);
        transform: scale(1.1);
      }
    }

    &.dragging {
      background: linear-gradient(
        to right,
        #dee2e6 0%,
        #adb5bd 50%,
        #dee2e6 100%
      );
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

      .drag-handle {
        background: rgba(108, 117, 125, 0.2);
        transform: scale(1.2);
      }
    }

    .drag-handle {
      width: 30px;
      height: 20px;
      border-radius: 50%;
      background: rgba(108, 117, 125, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      .drag-icon {
        color: #6c757d;
        transition: color 0.2s ease;
      }
    }

    /* 增加拖拽区域 */
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: -4px;
      bottom: -4px;
    }
  }

  .top,
  .bottom {
    position: relative;
  }

  .bottom {
    flex: 1;
  }
}
</style>
